<template>
    <el-main class="user-container" ref="user-container">
        <div class="main-box el-row">
            <div class="el-col el-col-5 tree-box">
                <div class="main-left">
                    <el-tree ref="departmentTree" :data="tree" node-key="id" :expand-on-click-node="false" highlight-current :default-expanded-keys="defaultExpandedKeys" @node-click="getDepartmentUserList">
                        <span class="custom-tree-node" slot-scope="{ node, data }">
                            <span>
                                <i class="el-icon-office-building" style="color: #2cadff; margin-right: 5px"></i>
                                <span>{{ node.label }}</span>
                            </span>
                            <span v-if="nodeCurrent == data.id" style="color: #2cadff; font-size: 16px">
                                <i class="el-icon-circle-plus-outline" @click="organizationDialog(node, data, 'add')"></i>
                                <i class="el-icon-edit" style="margin: 0 7px" @click="organizationDialog(node, data, 'edit')"></i>
                                <i class="el-icon-delete" @click="organizationDialog(node, data, 'delete')"></i>
                            </span>
                        </span>
                    </el-tree>
                </div>
            </div>

            <!-- 添加组织架构 -->
            <el-dialog :title="dialogOptions.dialogTitle" :visible.sync="dialogOptions.dialogVisible" width="25%" :before-close="closeDialog">
                <el-form ref="departmentForm" :model="departmentForm" label-width="80px" :rules="rules">
                    <el-form-item label="上级部门" prop="superiorName" v-if="dialogOptions.dialogType !== 'delete'">
                        <span>{{ departmentForm.parent_title }}</span>
                    </el-form-item>
                    <el-form-item label="部门名称" prop="title" v-if="dialogOptions.dialogType !== 'delete'">
                        <el-input v-if="dialogOptions.dialogType == 'add'" maxlength="20" show-word-limit v-model="departmentForm.title"></el-input>
                        <el-input v-if="dialogOptions.dialogType == 'edit'" maxlength="20" show-word-limit v-model="departmentForm.title"></el-input>
                    </el-form-item>
                    <el-form-item v-if="dialogOptions.dialogType == 'delete'">
                        <div>
                            <i class="el-icon-warning" style="color: red; margin-right: 5px"></i>删除部门后，该部门员工将会迁入上级部门
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="closeDialog">取消</el-button>
                        <el-button type="primary" v-if="dialogOptions.dialogType !== 'delete'" @click="submitDepartment('departmentForm')">提交</el-button>
                        <el-button type="primary" v-if="dialogOptions.dialogType == 'delete'" @click="submitDepartment('departmentForm')">确认删除</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>

            <div class="el-col el-col-19 table-container">
                <div>
                    <el-form :inline="true" :model="query">
                        <el-form-item>
                            <el-button-group>
                                <el-button type="danger" @click="$refs.edit.showCreateDrawer()">添加 </el-button>
                            </el-button-group>
                        </el-form-item>

                        <el-form-item>
                            <el-select v-model="query.role_id" filterable multiple collapse-tags placeholder="所属角色" class="handle-select mr10">
                                <el-option v-for="(row, index) in roleList" :key="index" :label="row.title" :value="row.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="query.city_id" filterable multiple collapse-tags placeholder="所在城市" class="handle-select mr10">
                                <el-option v-for="(row, index) in cityList" :key="index" :label="row.title" :value="row.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="query.keywords" placeholder="昵称、真实姓名或者手机号" clearable @clear="handleSearch" class="handle-input mr10"></el-input>
                        </el-form-item>

                        <el-form-item>
                            <el-button type="primary" @click="handleSearch">搜索</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-switch v-model="query.is_valid" active-text="只看在职" inactive-text="只看离职" active-value="1" inactive-value="0">
                            </el-switch>
                        </el-form-item>
                    </el-form>

                </div>

                <el-table :data="tableData" class="table-user" v-loading="loading" :height="tableHeight" :max-height="tableHeight">
                    <el-table-column prop="id" label="ID" show-overflow-tooltip align="center"></el-table-column>
                    <el-table-column prop="department.title" label="部门" show-overflow-tooltip align="center"> </el-table-column>
                    <el-table-column prop="role.title" label="角色" show-overflow-tooltip align="center"> </el-table-column>
                    <el-table-column prop="nickname" label="用户名" show-overflow-tooltip align="center"></el-table-column>
                    <el-table-column prop="realname" label="姓名" show-overflow-tooltip align="center"></el-table-column>
                    <el-table-column prop="mobile" label="手机" show-overflow-tooltip align="center"></el-table-column>
                    <el-table-column prop="sort" label="排序" show-overflow-tooltip align="center"></el-table-column>
                    <el-table-column prop="online" label="在线状态" show-overflow-tooltip align="center"></el-table-column>
                    <el-table-column prop="is_valid" label="在职状态" show-overflow-tooltip align="center">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.is_valid == 1" type="primary">在职</el-tag>
                            <el-tag v-else type="primary">离职</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="220" align="center">
                        <template #default="scope">
                            <el-button @click="$refs.edit.showEditDrawer(scope.row)" type="primary" size="mini">编辑</el-button>
                            <el-button @click="$refs.grant.showGrantDrawer(scope.row)" type="success" size="mini">数据权限</el-button>
                            <el-dropdown>
                                <el-button size="mini" type="primary" style="
                                        background-color: transparent;
                                        border-color: transparent;
                                        color: #009cff;
                                        background: transparent;
                                    ">
                                    <i class="el-icon-more"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click.native="bindWeChat(scope.row)">绑定微信号</el-dropdown-item>
                                    <el-dropdown-item @click.native="bindPhone(scope.row)">绑定手机号</el-dropdown-item>
                                    <el-dropdown-item @click.native="bindHotel(scope.row)">绑定酒店</el-dropdown-item>
                                    <el-dropdown-item @click.native="bindMerchant(scope.row)">外部商户</el-dropdown-item>
                                    <el-dropdown-item @click.native="setStatus(scope.row)">上下线</el-dropdown-item>
                                    <el-dropdown-item @click.native="showDrawerPass(_self, 'leave', 'showDrawer', [scope.row])">
                                        交接</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="footer-box">
                    <div class="download"></div>
                    <div class="pagination">
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.page" :page-sizes="[15, 30, 50, 100]" :page-size="pagination.limit" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
                    </div>
                </div>

                <!-- 编辑 -->
                <edit ref="edit" @getTableData="getTableData" :pickers="{ ...storeList, departmentList, sexList }" :roleList="roleList"></edit>
                <grant ref="grant" :cityList="cityList" :companyList="companyList" @getTableData="getTableData" />
                <phone ref="phone" @getTableData="getTableData" />
                <we-chat ref="weChat" @getTableData="getTableData" />
                <!-- 绑定酒店 -->
                <bind-hotel ref="bindHotel" :hotelList="hotelList" @getTableData="getTableData"></bind-hotel>
                <bind-merchant ref="bindMerchant"></bind-merchant>
            </div>
            <leave ref="leave"></leave>
        </div>
    </el-main>
</template>

<script>
import {
    showDrawerPass
} from '@/utils/common.js';
import BindHotel from './bindHotel.vue';
import bindMerchant from './bindMerchant.vue';
import edit from './edit';
import grant from './grant';
import phone from './phone';
import weChat from './weChat';
import leave from './leave';

const filterItem = {
    parent_title: '',
    parent_id: '',
    title: '',
    id: 0
};

export default {
    namespaced: true,
    name: 'Main',
    components: {
        edit,
        grant,
        phone,
        BindHotel,
        bindMerchant,
        leave,
        weChat
    },
    data() {
        let tableHeight = window.innerHeight - 230;
        return {
            loading: false,

            user: {},
            query: {
                department_id: '',
                role_id: [],
                city_id: [],
                is_valid: '1',
                keywords: ''
            },
            tableData: [],
            tableHeight: tableHeight,
            tree: [],
            // tree 默认展开节点
            defaultExpandedKeys: [],
            dialogOptions: {
                //弹窗选项
                dialogVisible: false,
                dialogTitle: '',
                dialogType: ''
            },

            storeList: [],
            departmentList: [],
            roleList: [],
            cityList: [],
            hotelList: [],

            // 订单公司
            companyList: [],

            sexList: [{
                id: 0,
                title: '女'
            },
            {
                id: 1,
                title: '男'
            }
            ],
            departmentForm: Object.assign({}, filterItem), //组织架构表单
            nodeCurrent: 0, //当前选中节点id
            rules: {
                //组织架构表单验证
                title: [{
                    required: true,
                    message: '请输入部门名称',
                    trigger: 'blur'
                }]
            },
            pagination: {
                page: 1,
                limit: 15,
                total: 0
            }
        };
    },
    created: function () {
        // 获取列表信息
        this.getTableData();
        // 获取树信息
        this.getTree();
        // 获取下拉列表
        this.getPickerList();
        // 获取角色列表
        this.getPicker();
    },
    beforeCreate() {
        this.showDrawerPass = showDrawerPass;
    },
    methods: {
        // 获取列表数据
        getTableData() {
            let that = this;
            let url = '/api/ucenter.user/index';
            let query = this.query;
            query['pagination'] = that.pagination;
            this.$post(url, query).then(function (response) {
                let result = response.data;
                that.tableData = result.list;
                that.pagination = result.pagination;
            });
        },
        // 获取角色，城市列表
        getPicker() {
            let that = this;
            let url = '/api/ucenter.picker/user';
            this.$post(url).then(function (res) {
                let result = res.data;
                that.roleList = res.data.roleList;
                that.cityList = res.data.cityList;
                that.hotelList = res.data.hotelList;
                that.companyList = res.data.companyList;
            });
        },
        // 获取Tree数据
        getTree() {
            let url = '/api/ucenter.department/getUserDepartmentTree';
            let that = this;
            this.$post(url, {}).then(function (response) {
                let tree = response.data.tree;
                that.tree = tree;
                that.defaultExpandedKeys = tree[0] ? [tree[0].id] : [];
            });
        },

        //添加组织架构弹窗
        organizationDialog(node, data, type) {
            this.dialogOptions.dialogVisible = true;
            if (type == 'add') {
                this.dialogOptions.dialogTitle = '新增部门';
                this.dialogOptions.dialogType = 'add';
                this.departmentForm.parent_id = data.id;
                this.departmentForm.parent_title = data.label;
            } else if (type == 'edit') {
                this.dialogOptions.dialogTitle = '编辑部门';
                this.dialogOptions.dialogType = 'edit';
                this.departmentForm.id = data.id;
                this.departmentForm.title = data.label;
                this.departmentForm.parent_id = node.parent.data.id;
                this.departmentForm.parent_title = node.parent.data.label;
            } else {
                this.dialogOptions.dialogTitle = '删除部门';
                this.dialogOptions.dialogType = 'delete';
                this.departmentForm.id = data.id;
                this.departmentForm.parent_id = node.parent.data.id;
                this.departmentForm.parent_title = node.parent.data.label;
            }
        },

        // 关闭弹窗
        closeDialog() {
            this.dialogOptions.dialogVisible = false;
            this.departmentForm = {
                parent_id: '',
                parent_title: '',
                title: ''
            };
        },

        // 确认添加/编辑/删除
        submitDepartment(data) {
            let that = this;
            let type = that.dialogOptions.dialogType;
            let url = '/api/ucenter.department/save';
            let query = that.departmentForm;
            if (type == 'add') {
                that.$refs['departmentForm'].validate((valid) => {
                    if (valid) {
                        that.$post(url, query).then(function (response) {
                            if (response.code != '200') {
                                that.$message.error(response.msg);
                            } else {
                                that.getTree();
                                that.closeDialog();
                                that.departmentForm = Object.assign({}, filterItem);
                                that.$message.success(response.msg);
                            }
                        });
                    } else {
                        that.$message('请填写完整并检查您的填写信息');
                    }
                });
            } else if (type == 'edit') {
                that.$refs['departmentForm'].validate((valid) => {
                    if (valid) {
                        that.$post(url, query).then(function (response) {
                            if (response.code != '200') {
                                that.$message.error(response.msg);
                            } else {
                                that.getTree(); //重新加载部门树
                                that.closeDialog();
                                that.departmentForm = Object.assign({}, filterItem);
                                that.$message.success(response.msg);
                            }
                        });
                    } else {
                        that.$message('请填写完整并检查您的填写信息');
                    }
                });
            } else {
                let url = '/api/ucenter.department/delete';
                that.$post(url, query).then(function (response) {
                    if (response.code != '200') {
                        that.$message.error(response.msg);
                    } else {
                        that.getTree(); //重新加载部门树
                        that.closeDialog();
                        that.departmentForm = Object.assign({}, filterItem);
                        that.$message.success(response.msg);
                    }
                });
            }
        },
        // 获取部门下的偶有员工
        getDepartmentUserList(data, node) {
            let that = this;
            that.nodeCurrent = data.id;
            let url = '/api/ucenter.user/index';
            let options = {};
            this.query.department_id = data.id;
            options = {
                ...this.query
            };
            options['pagination'] = this.pagination;

            that.$post(url, options).then(function (response) {
                if (response.code != '200') {
                    that.$message.error(response.msg);
                } else {
                    that.tableData = response.data.list;
                    that.pagination = response.data.pagination;
                }
            });
        },

        getPickerList() {
            let that = this;
            let url = '/api/customer.picker/items';
            this.$post(url, {}).then(function (response) {
                let result = response.data;
                that.departmentList = result.departmentList;
                that.storeList = result.storeList;
            });
        },

        // 搜索
        handleSearch() {
            this.getTableData();
        },

        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTableData();
        },

        // 绑定手机号
        bindPhone(options) {
            this.$refs['phone'].showPhoneDrawer(options);
        },
        // 绑定微信号
        bindWeChat(options) {
            this.$refs['weChat'].showweChatDrawer(options);
        },

        // 绑定酒店
        bindHotel(options) {
            this.$refs['bindHotel'].showDrawer(options);
        },
        // 绑定的外部商户
        bindMerchant(options) {
            this.$refs['bindMerchant'].show(options);
        },

        // 设置上下线
        setStatus(data) {
            let that = this;
            let url = '/api/ucenter.user/toggleLine';
            let apiParams = {
                online: data.online,
                user_id: data.id
            };
            if (apiParams.online == 0) {
                apiParams.online = 1;
                that.$confirm('当前用户状态是下线，是否切换为上线？', '提示', {})
                    .then(() => {
                        this.$post(url, apiParams).then(function (res) {
                            if (res.code == 200) {
                                that.$message.success(res.msg);
                                that.getTableData();
                            } else {
                                that.$message.error(res.msg);
                            }
                        });
                    })
                    .catch(() => {
                        this.$message('已取消');
                    });
            } else {
                apiParams.online = 0;
                that.$confirm('当前用户状态是上线，是否切换为下线？', '提示', {})
                    .then(() => {
                        this.$post(url, apiParams).then(function (res) {
                            if (res.code == 200) {
                                that.$message.success(res.msg);
                                that.getTableData();
                            } else {
                                that.$message.error(res.msg);
                            }
                        });
                    })
                    .catch(() => {
                        this.$message('已取消');
                    });
            }
        },

        // 离职
        leave(data) {
            let that = this;
            let params = {
                user_id: data.id
            };
            let url = '/api/ucenter.user/leave';
            that.$confirm('确认执行离职操作？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    this.$post(url, params).then(function (res) {
                        if (res.code == 200) {
                            that.$message.success(res.msg);
                            that.getTableData();
                        } else {
                            that.$message.error(res.msg);
                        }
                    });
                })
                .catch((err) => {
                    that.$message('已取消操作');
                });
        }
    }
};
</script>

<style lang="less" scoped>
.user-container {
    height: 100%;
    padding: 12px;
}

.content {
    width: auto;
    height: 100%;
    overflow-y: hidden;
}

.main-box {
    height: 100%;
    overflow: auto;
}

.tree-box {
    height: 100%;
    overflow: auto;
}

.table-container {
    padding-left: 10px;
    height: 100%;
}

.organization {
    height: 67px;
    line-height: 67px;
    font-size: 14px;
    font-weight: 500;
    color: #262626;
    padding-left: 18px;
    border-bottom: 1px solid #e8e8e8;
}

.left-icon {
    margin-right: 5px;
    color: #2cadff;
    font-size: 14px;
}

.company-name {
    display: flex;
    align-items: center;
    height: 52px;
    padding-top: 16px;
    font-size: 14px;
    padding-left: 7px;
}

.name {
    width: 70%;
}

.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}

.footer-box {
    margin-top: 12px;
    display: flex;
    align-items: center;

    .download {
        flex: 0 15%;
    }

    .pagination {
        margin: 0;
        flex: 1;
    }
}
</style>
